export default __webpack_public_path__ + "static/media/desk4.2ecc3813.png";